import { lazy } from 'react';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';

const Haccp = lazy(() => import('./Haccp'));

const HaccpRoute: FuseRouteItemType = {
	path: '/haccp',
	element: <Haccp />
};

export default HaccpRoute;
